export const getRiskColor = (riskLevel) => {
  const colors = {
    CRITICAL: "#dc3545",
    HIGH: "#fd7e14",
    MEDIUM: "#ffc107",
    LOW: "#28a745",
  };
  return colors[riskLevel?.toUpperCase()] || "#6c757d";
};

export const getRiskBackground = (riskLevel) => {
  const backgrounds = {
    CRITICAL: "#fff5f5",
    HIGH: "#fff8f0",
    MEDIUM: "#fffcf0",
    LOW: "#f0fff4",
  };
  return backgrounds[riskLevel?.toUpperCase()] || "#f8f9fa";
};
